import * as AC from 'components/actions/actionTypes';
import merge from 'lodash/merge';
import { STANDARD } from 'components/common/constants/authConstants';

let initialState = {
  serverRepondedToAjax: false,
  isLoadingContent: false,
  register: {
    email: '',
    name: '',
    phone: '',
    password: '',
    token: '',
    profile_id: '',
    type: STANDARD,
    phoneCountry: { value: 'norway', label: '+47' },
    errors: {},
  },
  customer: {
    id: '',
    name: '',
    email: '',
    phone: '',
    language: 'pl',
    invoice_company: '',
    invoice_address: '',
    invoice_tax_number: '',
    issue_invoice_each_booking: false
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AC.SET_BASIC_REGISTER_DATA:
      return merge({}, state, action.data);

    case AC.UPDATE_REGISTER_FIELDS:
      var newState = merge({}, state);
      merge(newState.register, action.hash);
      return newState;

    case AC.SET_USER_LOGGED:
      return merge({}, state, { customer: action.customer });

    case AC.SET_USER_LOGOUT:
      var newState = merge({}, state);
      newState.customer = initialState.customer;
      return newState;

    case AC.SHOW_SPLASH_SCREEN:
      return merge({}, state, { isLoadingContent: true });

    case AC.HIDE_SPLASH_SCREEN:
      return merge({}, state, { isLoadingContent: false });

    case AC.RESET_REGISTER_FIELDS:
      return merge({}, state, { register: initialState.register });

    case AC.RESET_REGISTER_ERRORS:
      var newState = merge({}, state);
      newState.register.errors = {};
      return newState;

    case AC.UPDATE_CUSTOMER_PHONE:
      var newState = merge({}, state);
      newState.customer.phone = action.phone;
      return newState;

    case AC.UPDATE_CUSTOMER_INVOICE_DATA:
      var newState = merge({}, state);
      newState.customer.invoice_company = action.invoiceData.invoiceCompany;
      newState.customer.invoice_address = action.invoiceData.invoiceAddress;
      newState.customer.invoice_tax_number = action.invoiceData.invoiceTaxNumber;
      newState.customer.issue_invoice_each_booking = action.invoiceData.issueInvoiceEachBooking;
      return newState;

    case AC.SET_SERVER_RESPONDED_TO_AJAX:
      return merge({}, state, { serverRepondedToAjax: action.value });

    default:
      return state;
  }
}
